import * as React from 'react';
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Header} from './Header/Header';
import { BodyRouter } from './Body/BodyRouter';
import { Foot } from './Foot/Foot';
import { Grommet } from 'grommet';
import { StylesProvider } from '@material-ui/core/styles';
import './App.css';

function App() {

  const [logged, setLogged] = useState(false);
  const [typeUser, setTypeUser] = useState('');
  const [corporation, setCorporation] = useState('');
  const [username, setUsername] = useState('');
  const url = 'https://rollin.lat';
  //const url = 'http://127.0.0.1:8000';
  const customTheme = {
    global: {
      colors: {
        // Overriding existing grommet colors
        brand: "var(--orange)",
        "accent-1": "#6FFFB0",
        "accent-2": "#7FFFB0",
        "accent-3": "#8FFFB0",
        "accent-4": "#9FFFB0",
        "neutral-1": "#10873D",
        "neutral-2": "#20873D",
        "neutral-3": "#30873D",
        "neutral-4": "#40873D",
        focus: "var(--orange)",
      }
    }
  };


  return (
    <StylesProvider injectFirst>
      <BrowserRouter>
        <Grommet theme={customTheme}>
          <Header
            logged={logged} 
            setLogged={setLogged} 
            url={url} 
            setTypeUser={setTypeUser} 
            typeUser={typeUser} 
            setUsername={setUsername} 
            username={username}
            setCorporation={setCorporation}
            corporation={corporation}
          />

          <BodyRouter
            logged={logged} 
            url={url} 
            typeUser={typeUser}
            corporation={corporation} 
            username={username}
          />
          
          <Foot
            typeUser={typeUser}
            corporation={corporation}
          /> 
        </Grommet>
      </BrowserRouter>
    </StylesProvider>
  );
}

export default App;
